import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Actions as ACTIONS } from "../../store/actions/leaveActions";

import ReactDOM from "react-dom";
// import axios from 'axios';
import Select from "react-select";
import _ from "lodash";
import DatePicker from "react-datepicker";
import { TimeInputFormat, DateInputFormat } from "../common/DateComponents";
import "react-datepicker/dist/react-datepicker.css";
import "react-notifications/lib/notifications.css";
import {
	format,
	subYears,
	addYears,
	setHours,
	setMinutes,
	setSeconds,
	setDate,
	differenceInDays,
	differenceInMinutes,
	endOfMonth,
} from "date-fns";
import { v4 as uuidv4 } from "uuid";
import { XMarkIcon, ArrowDownTrayIcon } from "@heroicons/react/20/solid";
import Spinner from "../common/Spinner";
import { employmentTypeOptions } from "../company-settings/config/employmentTypeOptions";
import Modal from "@/common/Modal";

const LeaveBalanceReportModal = ({
	departmentOptions,
	showLeaveBalanceReportModal,
	generateLeaveBalanceReport,
	generatingLeaveBalanceReport,
	showModal,
	// mySaveLeave
}) => {
	const [selectedDepartment, setSelectedDepartment] = useState();
	const [jobType, setJobType] = useState();
	const [active, setActive] = useState(true);
	const [includeContractors, setExternalContractors] = useState(false);
	const [selectedDate, setSelectedDate] = useState(endOfMonth(new Date()));

	const getReport = () => {
		const options = {
			department: (selectedDepartment && selectedDepartment.label) || "",
			jobType: (jobType && jobType.value) || "",
			leaveDate: format(selectedDate, "yyyy-MM-dd"),
			active,
			includeContractors,
		};

		generateLeaveBalanceReport(options);
	};

	return (
		<Modal
			status={showModal}
			close={() => showLeaveBalanceReportModal(false)}
			title="Leave Situation Report"
		>
			<div className="block-content">
				<div className="form-group">
					<div>
						<div className="col-xs-6">
							<label>As at</label>
							<DatePicker
								selected={selectedDate}
								onChange={(newFromDate) => {
									setSelectedDate(newFromDate);
								}}
								minDate={subYears(new Date(), 100)}
								maxDate={addYears(new Date(), 100)}
								dateFormat="do MMM yyyy"
								customInput={<DateInputFormat />}
							/>
							<div className="clearfix" />
						</div>

						<div className="col-xs-6">
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
									alignContent: "space-between",
									alignItems: "baseline",
									marginBottom: 10,
								}}
							>
								<div style={{ display: "inline-block", fontSize: "13px", fontWeight: 600 }}>
									{" "}
									Include Terminated Employees
								</div>
								<div
									title="Include Terminated Employees"
									className="form-material"
									style={{ minWidth: 43, display: "inline-block", margin: 0 }}
								>
									<label
										className="css-input switch switch-sm switch-primary"
										style={{ marginTop: 3, marginLeft: 10 }}
									>
										<input
											type="checkbox"
											checked={!active}
											onChange={(e) => setActive(!active)}
										/>
										<span />
									</label>
									<div className="clearfix" />
								</div>
							</div>

							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
									alignContent: "space-between",
									alignItems: "baseline",
									marginBottom: 10,
								}}
							>
								<div style={{ display: "inline-block", fontSize: "13px", fontWeight: 600 }}>
									{" "}
									Include External Contractors
								</div>
								<div
									title="Include External Contractors"
									className="form-material"
									style={{ minWidth: 43, display: "inline-block", margin: 0 }}
								>
									<label
										className="css-input switch switch-sm switch-primary"
										style={{ marginTop: 3, marginLeft: 10 }}
									>
										<input
											type="checkbox"
											checked={includeContractors}
											onChange={(e) => setExternalContractors(!includeContractors)}
										/>
										<span />
									</label>
									<div className="clearfix" />
								</div>
							</div>
						</div>

						<div className="clearfix" />
					</div>

					{departmentOptions && (
						<div
							className="col-sm-12"
							style={{ marginTop: 10 }}
						>
							<label htmlFor="material-text">Department</label>
							<Select
								value={selectedDepartment}
								options={departmentOptions}
								onChange={setSelectedDepartment}
								isClearable
							/>
							<div className="clearfix" />
						</div>
					)}
					<div
						className="col-sm-12"
						style={{ marginTop: 10 }}
					>
						<label htmlFor="material-text">Job Type</label>
						<Select
							value={jobType}
							options={employmentTypeOptions?.map((employmentType) => ({
								label: employmentType.label,
								value: employmentType.label,
							}))}
							onChange={setJobType}
							isClearable
						/>
						<div className="clearfix" />
					</div>
					<div className="clearfix" />
				</div>

				<button
					className="btn btn-success pull-right"
					onClick={() => (generatingLeaveBalanceReport ? "" : getReport())}
					style={{ marginRight: 0, marginBottom: "20px" }}
				>
					{generatingLeaveBalanceReport && (
						<Spinner
							style={{ marginRight: 10, verticalAlign: "text-bottom" }}
							className="animate-spin -ml-1 mr-3 h-7 w-7 "
						/>
					)}
					{!generatingLeaveBalanceReport && (
						<ArrowDownTrayIcon
							className="w-7 h-7"
							style={{ marginRight: 10, verticalAlign: "text-bottom" }}
						/>
					)}
					Download Report
				</button>

				<div className="clearfix" />
			</div>
		</Modal>
	);
};

const mapStateToProps = (state) => {
	const departmentOptions = state?.company?.settings?.departments?.map((department) => ({
		value: department.id,
		label: department.name,
	}));

	return {
		showModal: state.leave && state.leave.balanceReportModal,
		generatingLeaveBalanceReport: state.leave && state.leave.generatingLeaveBalanceReport,
		departmentOptions,
	};
};

const mapDispatchToProps = dispatch => ({
  showLeaveBalanceReportModal: (status) => dispatch(ACTIONS.showLeaveBalanceReportModal(status)),
  generateLeaveBalanceReport: (options) => dispatch(ACTIONS.generateLeaveBalanceReport(options)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LeaveBalanceReportModal) 
